module.exports = __webpack_public_path__ + "static/media/6.bbff0cf8.JPG";